import Sidemenu from './sidemenu';
import RoutecontainerUnAuth from './routecontainerUnAuth';
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
class ContainerUnAuth extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12" style={{ minHeight: '90vh', maxHeight: '90vh', overflowY: 'scroll' }}>
                    <RoutecontainerUnAuth />
                </div>
            </div>
        )
    }

}
export default ContainerUnAuth